// src/app/guards/super-admin.guard.ts

import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { AuthService } from '../services/auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    const isAdmin = this.authService.isSuperAdmin();
    if (isAdmin) {
      return true;
    }
    // Wenn nicht SuperAdmin, weiterleiten oder 403-Seite anzeigen
    return this.router.parseUrl('/forbidden');
  }
}
